export default __webpack_public_path__ + "static/aij-8b8d351e12f601d03e72aba97d5378f6.svg";